/**
 * L'adresse d'un enregistrement, telle qu'un lecteur peut la jouer.
 *
 * 🚨 L'URL stockee pointe sur api.twilio.com, qui exige une authentification :
 * la donner a une balise <audio> fait ouvrir au navigateur sa fenetre
 * « Se connecter a Twilio ». Vu le 2026-09-30 en depliant le fil d'activite.
 * Tout ce qui joue ou telecharge un enregistrement passe donc par le relais
 * du serveur, qui porte les identifiants.
 *
 * La reparation d'URL et la construction du lien existaient en trois copies
 * (historique, fiche contact, portail client), recopiees a chaque nouvel
 * ecran. Une quatrieme a oublie le relais, d'ou ce module.
 */

const PREFIXE_DOUBLE = 'https://api.twilio.comhttps://api.twilio.com';

/**
 * Certains enregistrements ont ete stockes avec le domaine Twilio deux fois.
 * La base n'a pas ete reecrite, la lecture repare donc a la volee.
 */
export function fixRecordingUrl(url: string | null | undefined): string {
  if (!url) return '';
  return url.startsWith(PREFIXE_DOUBLE) ? url.replace(PREFIXE_DOUBLE, 'https://api.twilio.com') : url;
}

/** L'adresse a donner a un lecteur audio, ou une chaine vide s'il n'y a rien. */
export function recordingPlaybackUrl(url: string | null | undefined): string {
  const propre = fixRecordingUrl(url);
  if (!propre) return '';
  return `/api/twilio/recording-proxy?url=${encodeURIComponent(propre)}`;
}

/** La meme adresse, mais qui declenche un telechargement sous ce nom. */
export function recordingDownloadUrl(url: string | null | undefined, filename: string): string {
  const lecture = recordingPlaybackUrl(url);
  if (!lecture) return '';
  return `${lecture}&download=1&filename=${encodeURIComponent(filename)}`;
}
